/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    ONLY_THIS: 'ONLY_THIS',
    ALL_FUTURE:'ALL_FUTURE',
    ALL:'ALL',
};
